import { BaseEntity, Entity as DecribeEntity } from '@lib/entity';

import type {
    UserGrantsTableItem,
    UserGrantCategoryToken,
    UserGrantActionToken,
} from '@modules/types/graphql';

export type Entity = UserGrantsTableItem | null;

@DecribeEntity('UserGrantsTableItemEntity')
class UserGrantsTableItemEntity extends BaseEntity {
    id: string;
    category: UserGrantCategoryToken;
    action: UserGrantActionToken;
    granted: boolean;

    constructor(entity: Entity) {
        super(entity);

        this.id = entity?.id ?? '';
        this.category = (entity?.category ?? '') as UserGrantCategoryToken;
        this.action = (entity?.action ?? '') as UserGrantActionToken;
        this.granted = entity?.granted ?? false;
    }

    exists() {
        return this.id !== '';
    }

    toJSON() {
        return {
            id: this.id,
            category: this.category,
            action: this.action,
            granted: this.granted,
        };
    }
}

export { UserGrantsTableItemEntity };
